import styled from 'styled-components'

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  input{
    box-sizing: border-box;
    width: 100%;
    margin: 10px;
  }
`

export const FormContainer = styled.div`
  button{
    width: 100%;
    margin: 10px;
  }
`
